import React, { Component } from 'react';
import ReactModal from 'react-modal';
import { connect } from 'react-redux';
import CardAttachModal from '../CardAttachModal';
import CardEditingModal from '../CardEditingModal';

class MyPaymentSettings extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showPaymentModal: false,
            showEditPaymentModal: false,
        }
    }

    /// README: MODAL CONTROLLING
    handleOpenNewPaymentModal = () => {
        this.setState({ showPaymentModal: true });
    }

    handleCloseNewPaymentModal = () => {
        this.setState({ showPaymentModal: false });
    }

    handleOpenEditPaymentModal = () => {
        this.setState({ showEditPaymentModal: true });
    }

    handleCloseEditPaymentModal = () => {
        this.setState({ showEditPaymentModal: false });
    }

    render() {
        const subTitleStyle = {
            fontSize: '14px',
            fontWeight: 'bold',
        };
        const titleStyle = {
            fontSize: '16px',
            fontWeight: 'bold',
        };
        const { hasStripeCusId, modalStyles } = this.props;
        return (
            <React.Fragment>
                <div className="text-left p-4">
                    <h5 style={titleStyle}><b>Change card settings or setup a new card as default</b></h5>

                    {!hasStripeCusId ? <div className="pt-3">
                        <hr />
                        <h5 style={subTitleStyle}>Setup a new card</h5>
                        <hr />
                        <p>Attaching a card is essential when you are planning to subscribe to any of our plans. Please note that your <b>card information is not stored on our cloud server but is held by Stripe (a trusted and secure company).</b></p>
                        <button className="btn btn-dark btn-sm mt-3" onClick={this.handleOpenNewPaymentModal}>Click here to attach a card</button>
                    </div> : <React.Fragment />}

                    {hasStripeCusId ? <div className="pt-3">
                        <hr />
                        <h5 style={subTitleStyle}>Edit details</h5>
                        <hr />
                        <p>Change the details of your card that is already registered as default.</p>
                        <button className="btn btn-warning btn-sm mt-3" style={{ borderRadius: '10px' }} onClick={this.handleOpenEditPaymentModal}>Edit your card</button>
                    </div> : <React.Fragment />}

                    {hasStripeCusId ? <div className="pt-3">
                        <hr />
                        <h5 style={subTitleStyle}>Set up a new card as default</h5>
                        <hr />
                        <p>Enter the details of a new card and make it as default. Once this happens, the <b> payments for your existing subscriptions will be charged from the new card. </b> </p>
                        <button className="btn btn-warning btn-sm mt-3" style={{ borderRadius: '10px' }} onClick={this.handleOpenNewPaymentModal}>Click here to attach a new card</button>
                    </div> : <React.Fragment />}
                </div>

                {/* PAYMENT EDITING MODAL */}
                <ReactModal
                    style={modalStyles}
                    isOpen={this.state.showEditPaymentModal}
                    onRequestClose={() => { this.handleCloseEditPaymentModal() }}
                    contentLabel="Payment method edit"
                    ariaHideApp={false}
                >
                    <button className="close" onClick={() => { this.handleCloseEditPaymentModal() }}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <CardEditingModal />
                </ReactModal>

                {/* NEW PAYMENT MODAL */}
                <ReactModal
                    style={modalStyles}
                    isOpen={this.state.showPaymentModal}
                    onRequestClose={() => { this.handleCloseNewPaymentModal() }}
                    contentLabel="New payment method"
                    ariaHideApp={false}
                >
                    <button className="close" onClick={() => { this.handleCloseNewPaymentModal() }}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <CardAttachModal />
                </ReactModal>
            </React.Fragment >
        );
    }
}

const mapStateToProps = (state) => {
    return {
        modalStyles: state.appControl.modalStyles,
    }
}

export default connect(mapStateToProps)(MyPaymentSettings);